//import { createBreakpoints } from '@mui/material/styles';

//export const breakpoints = createBreakpoints({});
export const spacing = 8
